import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
// import Table from '@material-ui/core/Table';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
// import GochiMenuTableHead from '../../components/molecules/GochiMenuTableHead';
// import GochiMenuTableBody from '../../components/molecules/GochiMenuTableBody';
// import TablePagination from '../../components/molecules/TablePagination';
// import ExPagination from '../../components/molecules/ExPagination';
import GochiChildFoodListDetailShop from './GochiChildFoodListDetailShop';
import GochiChildFoodListEditShop from './GochiChildFoodListEditShop';
import DeleteDialog from '../../components/molecules/DeleteDialog';
// import DeleteDialog from '../../components/molecules/DeleteDialog';
import ProgressDialog from '../../components/molecules/ProgressDialog';
// import ShowHideDialog from '../../components/molecules/ConfirmDialog';
import DetailTextButton from '../../components/atoms/DetailTextButton';
import EditTextButton from '../../components/atoms/EditTextButton';
import DeleteTextButton from '../../components/atoms/DeleteTextButton';
// import ShowHideTextButton from '../../components/atoms/ShowHideTextButton';
// import ShowHideSwitchButton from '../../components/atoms/ShowHideSwitchButton';
// import CoppyButton from '../../components/atoms/CoppyButton';
import {
  getGochiChildFoodLists,
  getGochiChildFoodListDetail,
  deleteGochiChildFoodList
  //   showHideGochiMenu
} from '../../actions/GochiChildFoodLists';
import { sendLogin } from '../../auth/Auth';

const styles = {
  scrollTable: {
    maxHeight: 375,
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  },
  lstMenu: {
    padding: 0
  },
  menuItem: {
    padding: 10,
    borderTop: '1px solid #DBDBDB'
  },
  menuCard: {
    boxShadow: 'none',
    width: '100%',
    borderRadius: 0
  },
  menuCnt: {
    padding: 0,
    display: 'flex',
    marginBottom: 12
  },
  menuImg: {
    width: 80,
    boxShadow:
      '0px 3px 3px -2px rgba(0,0,0,0.2), 0px 3px 4px 0px rgba(0,0,0,0.14), 0px 1px 8px 0px rgba(0,0,0,0.12)'
  },
  menuInfo: {
    paddingLeft: 12,
    width: 'calc(100% - 80px)'
  },
  menuName: {
    fontSize: 16,
    color: '#000000',
    marginBottom: 5,
    whiteSpace: 'normal',
    fontWeight: 'bold',
    wordBreak: 'break-all'
  },
  groupName: {
    fontSize: 12,
    fontWeight: 'bold',
    color: 'rgba(0,0,0,0.54)',
    padding: '2px 5px',
    borderRadius: 5,
    border: '1px solid #DBDBDB'
  },
  cardActions: {
    backgroundColor: '#F7F7F7',
    justifyContent: 'center',
    padding: '5px 10px'
  },
  marginRight10: {
    display: 'inline-block',
    marginRight: 10
  },
  ticket: {
    fontSize: 12,
    color: 'rgba(0, 0, 0, 0.87)'
  },
  modalMobile: {
    maxWidth: 380,
    margin: 'auto',
    padding: '5% 12px 5%'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      menus: state.gochiMenus.menus,
      totalCount: state.gochiMenus.totalCount,
      offset: state.gochiMenus.offset
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getGochiChildFoodLists,
          getGochiChildFoodListDetail,
          deleteGochiChildFoodList
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openDetailModal', 'updateOpenDetailModal', false),
  withState('openEdit', 'updateOpenEdit', false),
  withState('openEditConfirm', 'updateOpenEditConfirm', false),
  withState('openEditModal', 'updateOpenEditModal', false),
  withState('openDelete', 'updateOpenDelete', false),
  withState('openDeleteProgress', 'updateOpenDeleteProgress', false),
  withState('loading', 'updateLoading', false),
  withState('isDeleteSuccess', 'updateIsDeleteSuccess', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('shopId', 'setShopId', 0),
  withState('shopName', 'setShopName', ''),
  withState('groupId', 'setGroupId', 0),
  withState('groupName', 'setGroupName', ''),
  withState('childFoodId', 'setChildFoodId', 0),
  withState('childFoodName', 'setChildFoodName', ''),
  withState('menuChild', 'setMenuChild', ''),
  withState('childFoodDescription', 'setChildFoodDescription', ''),
  withState('childFoodImage', 'setChildFoodImage', null),
  withState('previewImage', 'setPreviewImage', null),
  withState('updatedAt', 'setUpdatedAt', ''),
  withState('createdAt', 'setCreatedAt', ''),
  withState('targetRowId', 'setTargetRowId', 0),
  withState('otherLanguages', 'setOtherLanguages', {}),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    checkSession,
    progress,
    searchKey,
    name,
    openDetailModal,
    updateOpenDetailModal,
    openDelete,
    updateOpenDelete,
    targetRowId,
    setTargetRowId,
    openEdit,
    updateOpenEdit,
    openEditConfirm,
    updateOpenEditConfirm,
    openDeleteProgress,
    updateOpenDeleteProgress,
    loading,
    updateLoading,
    isDeleteSuccess,
    updateIsDeleteSuccess,
    resultMessage,
    setResultMessage,
    shopId,
    setShopId,
    shopName,
    setShopName,
    groupId,
    setGroupId,
    groupName,
    setGroupName,
    childFoodId,
    setChildFoodId,
    childFoodName,
    setChildFoodName,
    childFoodDescription,
    setChildFoodDescription,
    childFoodImage,
    setChildFoodImage,
    menuChild,
    setMenuChild,
    createdAt,
    setCreatedAt,
    updatedAt,
    setUpdatedAt,
    handleChangePageChildFood,
    listMenus,
    otherLanguages,
    setOtherLanguages
  }) => {
    // const emptyRows =
    //   rowsPerPage - Math.min(rowsPerPage, totalCount - page * rowsPerPage);
    // const paramShowHide = {
    //   showHide
    // };
    const detail = {
      shopId,
      shopName,
      groupId,
      groupName,
      childFoodId,
      childFoodName,
      childFoodDescription,
      childFoodImage,
      menuChild,
      createdAt,
      updatedAt,
      otherLanguages
    };
    const getGochiChildFoodList = async id => {
      await actions.getGochiChildFoodListDetail(id).then(detailData => {
        checkSession(detailData);
        setShopId(detailData.payload.shop.shopId);
        setShopName(detailData.payload.shop.shopName);
        setGroupId(detailData.payload.group.groupId);
        setGroupName(detailData.payload.group.groupName);
        setChildFoodId(detailData.payload.childFoodId);
        setChildFoodName(detailData.payload.childFoodName);
        setChildFoodDescription(detailData.payload.childFoodDescription);
        setChildFoodImage(detailData.payload.childFoodImage);
        setMenuChild(detailData.payload.menuChild);
        setCreatedAt(detailData.payload.createdAt);
        setUpdatedAt(detailData.payload.updatedAt);
        setOtherLanguages(detailData.payload.otherLanguages);
      });
    };
    const detailOpenAction = params => {
      progress.updateLoading(true);
      progress.updateOpenProgress(true);
      getGochiChildFoodList(params.id)
        .then(() => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
          updateOpenDetailModal(true);
        })
        .catch(() => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
        });
    };
    const editOpenAction = id => {
      progress.updateLoading(true);
      progress.updateOpenProgress(true);
      getGochiChildFoodList(id)
        .then(() => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
          updateOpenEdit(true);
        })
        .catch(error => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
          console.log(error);
        });
    };
    const deleteOpenAction = id => {
      updateOpenDelete(true);
      setTargetRowId(id);
    };
    const cancelAction = () => updateOpenDelete(false);
    const deleteAction = async () => {
      updateLoading(true);
      updateOpenDeleteProgress(true);
      const deletedChildFoodList = await actions
        .deleteGochiChildFoodList(targetRowId)
        .then(data => checkSession(data));
      if (deletedChildFoodList.type === 'DELETE_GOCHI_CHILD_FOOD_SUCCESS') {
        updateIsDeleteSuccess(true);
        handleChangePageChildFood(null, 1, 10);
        setResultMessage('削除が完了しました。');
        updateLoading(false);
      } else {
        updateIsDeleteSuccess(false);
        setResultMessage(
          'メニューが購入されているため、削除できません。非表示設定をすると新規の購入ができなくなります。'
        );
        updateLoading(false);
      }
    };

    const progressOkAction = () => {
      if (isDeleteSuccess) {
        updateOpenDelete(false);
        updateOpenDeleteProgress(false);
      } else {
        updateOpenDeleteProgress(false);
      }
    };

    const index = 1;

    return (
      <div>
        {listMenus && (
          <List dense={false} className={classes.lstMenu}>
            {listMenus.map(gochiMenu => {
              const params = {
                id: gochiMenu.childFoodId
              };

              const key = `${gochiMenu.childFoodId}-${gochiMenu.shop.shopId}-${
                gochiMenu.group.groupName
              }`;
              return (
                <ListItem
                  className={classes.menuItem}
                  key={key}
                  tabIndex={index + 1}
                >
                  <Card className={classes.menuCard}>
                    <CardContent className={classes.menuCnt}>
                      <Box className={classes.boxImg}>
                        <CardMedia
                          component="img"
                          alt={gochiMenu.childFoodName}
                          width="80"
                          image={
                            (gochiMenu.childFoodImage &&
                              gochiMenu.childFoodImage[0].image) ||
                            'images/logo.png'
                          }
                          title={gochiMenu.childFoodName}
                          className={classes.menuImg}
                        />
                      </Box>
                      <Box className={classes.menuInfo}>
                        <Typography
                          gutterBottom
                          variant="h5"
                          component="h5"
                          className={classes.menuName}
                        >
                          {gochiMenu.childFoodName}
                        </Typography>
                        <Typography
                          gutterBottom
                          variant="p"
                          component="p"
                          className={classes.groupName}
                        >
                          {gochiMenu.group.groupName}
                          (グループ)
                        </Typography>
                        <Typography
                          gutterBottom
                          variant="p"
                          component="p"
                          className={classes.ticket}
                        >
                          お食事券:
                          {!gochiMenu.group.menu && (
                            <span style={{ color: 'red' }}> 未登録</span>
                          )}
                          {gochiMenu.group.menu &&
                            gochiMenu.group.menu.menuId &&
                            gochiMenu.group.menu.menuId}
                        </Typography>
                      </Box>
                    </CardContent>

                    <CardActions className={classes.cardActions}>
                      <DetailTextButton
                        params={params}
                        onClickAction={detailOpenAction}
                      />
                      <EditTextButton
                        id={gochiMenu.childFoodId}
                        onClickAction={editOpenAction}
                      />
                      <DeleteTextButton
                        id={gochiMenu.childFoodId}
                        onClickAction={deleteOpenAction}
                      />
                    </CardActions>
                  </Card>
                </ListItem>
              );
            })}
          </List>
        )}

        <Modal
          open={openDetailModal}
          onClose={() => {
            updateOpenDetailModal(false);
          }}
          className={classes.modalMobile}
        >
          <GochiChildFoodListDetailShop
            updateOpenDetailModal={updateOpenDetailModal}
            updateOpenEditModal={updateOpenEdit}
            detail={detail}
          />
        </Modal>
        <Modal open={openEdit} className={classes.modalMobile}>
          <GochiChildFoodListEditShop
            name={name}
            openEditConfirm={openEditConfirm}
            updateOpenEdit={updateOpenEdit}
            updateOpenEditConfirm={updateOpenEditConfirm}
            editInput={detail}
            searchKey={searchKey}
            handleChangePageChildFood={handleChangePageChildFood}
          />
        </Modal>
        <DeleteDialog
          openDelete={openDelete}
          updateOpenDelete={updateOpenDelete}
          cancelAction={cancelAction}
          deleteAction={deleteAction}
          targetRowId={targetRowId}
          target="メニュー"
        />

        <ProgressDialog
          openProgress={openDeleteProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
